import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class MixesDataAccess {
  mixList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData("Mixes/getAll", parameters);
  };

  getMixById = (procedureId: number) => {
    return commonDataAccess.getData("Mixes/get/mixesById", {
      id: procedureId,
    });
  };
  saveMix = (payload: any) => {
    return commonDataAccess.postData("Mixes/save/Mix", payload);
  };

  deleteMix = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData("Mixes/deleteAll", ids);
    } else {
      return commonDataAccess.deleteData(`Mixes/delete/${ids}`);
    }
  };

  completedMixList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "Mixes/getAllCompletedMix",
      parameters,
    );
  };
  productsMixList = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "Mixes/getAll-products-mix-data",
      parameters,
    );
  };

  getCompletedMixDetailById = (procedureId: number) => {
    return commonDataAccess.getData("Mixes/get/completedMixDetailById", {
      id: procedureId,
    });
  };

  getMixDropdown = () => {
    return commonDataAccess.getData("Mixes/get/mixDropdownList");
  };
  getProductMixDetailById = (procedureId: number) => {
    return commonDataAccess.getData("Mixes/get/product-mixesById", {
      id: procedureId,
    });
  };
}

export default new MixesDataAccess();
